import { BehaviorSubject } from "rxjs";
import ApiCore from "./common/api-core";
import { handleResponse } from "../helpers";

// Get current Token value
const url = "CalendarApi";

const apiTasks = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  postNotConnected: true,
  put: false,
  patch: true,
  delete: false,
  url: url,
});

export const scheduleService = {
  send,
  sendNotConnected,
  update,
  updateNotConnected,
  remove,
  removeNotConnected,
  acceptScheduleProposition,
  refuseScheduleProposition,
  getEventTypeConfiguration,
  getEventTypeByUserConfiguration,
  createEventTypeConfiguration
};

// send a schedule
function send(schedule) {
  return apiTasks.post("AddSchedule", schedule)
    .then(function (response) {
      // Only return the actual response object
      if (!response.isAxiosError) {
        return response.data; // assuming API wraps in `.data`
      } else {
        throw response;
      }
    })
    .catch(err => {
      console.error("Send failed:", err);
      return { succeeded: false };
    });
}

function sendNotConnected(schedule) {
  return apiTasks.postNotConnected("AddScheduleNotConnected", schedule)
    .then(function (response) {
      debugger;

      if (!response.isAxiosError) {
        return response.data; // assuming API wraps in `.data`
      } else {
        throw response;
      }
    })
    .catch(err => {
      console.error("Send failed:", err);
      return { succeeded: false };
    });
}

// update a schedule
function update(schedule) {
  return apiTasks.post("UpdateSchedule", schedule).then(function (response) {
    if (!response.isAxiosError) {
      return response;
    }
  });
}

// update a schedule
function updateNotConnected(schedule) {
  return apiTasks.postNotConnected("UpdateScheduleNotConnected", schedule).then(function (response) {
    if (!response.isAxiosError) {
      return response;
    }
  });
}

// delete
function remove(schedule) {
 // 
  return apiTasks.post("DeleteSchedule", schedule).then(function (response) {
    if (!response.isAxiosError) {
      return response;
    }
  });
}

function removeNotConnected(schedule) {
 // 
  return apiTasks.postNotConnected("DeleteScheduleNotConnected", schedule).then(function (response) {
    if (!response.isAxiosError) {
      return response;
    }
  });
}

// update a schedule
function acceptScheduleProposition(schedule) {
  return apiTasks.post("SchedulePropositionAcceptedByUser", schedule).then(function (response) {
    if (!response.isAxiosError) {
      return response;
    }
  });
}


// update a schedule
function refuseScheduleProposition(schedule) {
  return apiTasks.post("SchedulePropositionRefusedByUser", schedule).then(function (response) {
    if (!response.isAxiosError) {
      return response;
    }
  });
}


function getEventTypeConfiguration(title) {
 // 
  return apiTasks.postNotConnected("GetEventTypeConfigurationNotConnected", {title}).then(function (response) {
    if (!response.isAxiosError) {
      return response;
    }
  });
}


// function getEventTypeByUserConfiguration(userId) {
//  // 
//   return apiTasks.post("GetEventTypeByUserConfiguration", {userId}).then(function (response) {
//     if (!response.isAxiosError) {
//       return response;
//     }
//   });
// }

function getEventTypeByUserConfiguration() {
    return apiTasks.post('GetEventTypeConfigurationByToken')
    .then(response => {
        return response;
    });
}

function createEventTypeConfiguration(eventTypeConfiguration) {
    return apiTasks.post('CreateEventTypeConfiguration', eventTypeConfiguration)
    .then(response => {
        return response;
    });
}

